import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function AccountReport(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [otData, setotData] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [depData, setDepData] = useState([]);
  const [chqData, setChqData] = useState([]);
  const [bank, setBank] = useState({ bank: '' });

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
   
   const handleUser = (event) => {
      setBank({
        ...bank,
        bank: event.target.value
      });
    };

  useEffect(() => {
      fetchotData();
      const intervalId = setInterval(fetchotData, 5000);
      return () => clearInterval(intervalId);
  }, [startDate, endDate, bank]);

  function fetchotData() {
      const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
      const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
      const url = `${baseUrl}account-view/?start_date=${startDateString}&end_date=${endDateString}&bank=${bank.bank}`;
      axios.get(url)
      .then(response => {
        const { dep_pays, chq_pays } = response.data;
        setDepData(dep_pays);
        setChqData(chq_pays);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchBankData();
  }, []);

  function fetchBankData() {
      axios
        .get(`${baseUrl}add-bank/`)
        .then(response => {
          const bankData = response.data;
          setBankData(bankData);
        })
        .catch(error => {
          console.log(error);
        });
  }
  const columns1 = [
    { field: 'id', headerName: 'Id', width: 50 },
    { field: 'che_date', headerName: 'Cheque Date', width: 100 },
    { field:'bank__bank', headerName:'Bank Name',width:110},
    { field: 'paid', headerName: 'Paid To', width: 150},
    { field: 'acc_head', headerName: 'Account Head', width: 150},
    { field: 'amount', headerName: 'Amount', width: 100},
    { field: 'cheque', headerName: 'Ref No', width: 120},
    { field: 'memo', headerName: 'Memo', width: 160},
  ];
  const columns = [
    { field: 'id', headerName: 'Id', width: 50 },
    { field: 'dep_date', headerName: 'Deposit Date', width: 100 },
    { field:'bank__bank', headerName:'Bank Name',width:110},
    { field: 'pay_type', headerName: 'Pay Type', width: 90 },
    { field: 'received', headerName: 'Received From', width: 150},
    { field: 'acc_head', headerName: 'Account Head', width: 150},
    { field: 'amount', headerName: 'Amount', width: 100},
    { field: 'refno', headerName: 'Ref No', width: 120},
    { field: 'memo', headerName: 'Memo', width: 160},
  ];

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Account Statement Date-wise</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
         <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
            </div>
            <div className="mb-4 mt-4">
              <label htmlFor="bank" className="form-label">Bank</label>
                <select name="bank" id="bank" value={bank.bank} className="form-control"
                onChange={(event) => handleUser(event)}>
                  <option>Select Bank </option>
                  {bankData.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.bank}
                    </option>
                  ))}
                </select>
            </div>
          </div>
        </div>
      </div>


        <div style={{ height: "100%", width: "100%" }}>
          {depData.length > 0 && (
            <>
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
                <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{ color: 'red' }}></i> Deposit Statement
              </h3>
              <DataGrid className="mt-4 mb-5"
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={depData}
                columns={columns}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                }}
                autoHeight
              />
            </>
          )}
          {chqData.length > 0 && (
            <>
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
                <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{ color: 'red' }}></i> Cheque Statement
              </h3>
              <DataGrid className="mt-4 mt-5"
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={chqData}
                columns={columns1}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                }}
                autoHeight
              />
            </>
          )}
        </div>
    </section>
  )
}

export default AccountReport;
